import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Card, CardContent } from "@tabipla/ui";

export function TermsPage() {
  const { t } = useTranslation();

  const sections = [
    "intro",
    "definitions",
    "account",
    "prohibited",
    "ip",
    "privacy",
    "disclaimer",
    "liability",
    "changes",
    "contact",
  ];

  return (
    <div className="animate-fade-in py-12 sm:py-16">
      <div className="mx-auto max-w-3xl px-4">
        {/* Header */}
        <div className="mb-8 text-center">
          <h1 className="mb-2 text-3xl font-bold sm:text-4xl">{t("terms.title")}</h1>
          <p className="text-muted-foreground">{t("common.lastUpdated")}: 2026-01-29</p>
        </div>

        {/* Table of Contents */}
        <Card className="mb-8">
          <CardContent className="p-6">
            <h2 className="mb-4 font-semibold">目次</h2>
            <ol className="space-y-1 text-sm">
              {sections.map((section) => (
                <li key={section}>
                  <a
                    href={`#${section}`}
                    className="text-muted-foreground hover:text-primary hover:underline"
                  >
                    {t(`terms.${section}.title`)}
                  </a>
                </li>
              ))}
            </ol>
          </CardContent>
        </Card>

        {/* Content */}
        <div className="space-y-8">
          {/* 1. Introduction */}
          <section id="intro">
            <h2 className="mb-3 text-xl font-semibold">{t("terms.intro.title")}</h2>
            <p className="text-muted-foreground">{t("terms.intro.content")}</p>
          </section>

          {/* 2. Definitions */}
          <section id="definitions">
            <h2 className="mb-3 text-xl font-semibold">{t("terms.definitions.title")}</h2>
            <p className="mb-3 text-muted-foreground">{t("terms.definitions.content")}</p>
            <ul className="list-inside list-disc space-y-2 text-muted-foreground">
              <li>{t("terms.definitions.items.service")}</li>
              <li>{t("terms.definitions.items.apps")}</li>
              <li>{t("terms.definitions.items.user")}</li>
            </ul>
          </section>

          {/* 3. Account */}
          <section id="account">
            <h2 className="mb-3 text-xl font-semibold">{t("terms.account.title")}</h2>
            <p className="text-muted-foreground">{t("terms.account.content")}</p>
          </section>

          {/* 4. Prohibited */}
          <section id="prohibited">
            <h2 className="mb-3 text-xl font-semibold">{t("terms.prohibited.title")}</h2>
            <p className="mb-3 text-muted-foreground">{t("terms.prohibited.content")}</p>
            <ul className="list-inside list-disc space-y-2 text-muted-foreground">
              {(t("terms.prohibited.items", { returnObjects: true }) as string[]).map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </section>

          {/* 5. IP */}
          <section id="ip">
            <h2 className="mb-3 text-xl font-semibold">{t("terms.ip.title")}</h2>
            <p className="text-muted-foreground">{t("terms.ip.content")}</p>
          </section>

          {/* 6. Privacy */}
          <section id="privacy">
            <h2 className="mb-3 text-xl font-semibold">{t("terms.privacy.title")}</h2>
            <p className="text-muted-foreground">
              {t("terms.privacy.content")}{" "}
              <Link to="/privacy" className="text-primary hover:underline">
                {t("common.privacy")}
              </Link>
            </p>
          </section>

          {/* 7. Disclaimer */}
          <section id="disclaimer">
            <h2 className="mb-3 text-xl font-semibold">{t("terms.disclaimer.title")}</h2>
            <p className="text-muted-foreground">{t("terms.disclaimer.content")}</p>
          </section>

          {/* 8. Liability */}
          <section id="liability">
            <h2 className="mb-3 text-xl font-semibold">{t("terms.liability.title")}</h2>
            <p className="text-muted-foreground">{t("terms.liability.content")}</p>
          </section>

          {/* 9. Changes */}
          <section id="changes">
            <h2 className="mb-3 text-xl font-semibold">{t("terms.changes.title")}</h2>
            <p className="text-muted-foreground">{t("terms.changes.content")}</p>
          </section>

          {/* 10. Contact */}
          <section id="contact">
            <h2 className="mb-3 text-xl font-semibold">{t("terms.contact.title")}</h2>
            <p className="text-muted-foreground">{t("terms.contact.content")}</p>
          </section>
        </div>
      </div>
    </div>
  );
}
